(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-about-artisans"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-artisans"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      roots.forEach(function(el){ io.observe(el); });
    }

    document.querySelectorAll('[data-section-type="cs-about-artisans"]').forEach(function(root){
      var tabs = root.querySelectorAll('[data-as-tab-index]');
      var panels = root.querySelectorAll('[data-as-panel-index]');
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var idx = tab.getAttribute('data-as-tab-index');
          tabs.forEach(function(t){
            var on = t.getAttribute('data-as-tab-index') === idx;
            t.classList.toggle('as-tab--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function(p){
            var on = p.getAttribute('data-as-panel-index') === idx;
            p.classList.toggle('as-panel--hidden', !on);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-cta-strip"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-cta-strip"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-impact"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-impact"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-mission-vision"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-mission-vision"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-section-type="cs-about-timeline"]');
    roots.forEach(function (root) {
      var buttons = root.querySelectorAll('.at-year-btn');
      var img = root.querySelector('.at-detail-img');
      var yearEl = root.querySelector('.at-detail-year');
      var titleEl = root.querySelector('.at-detail-title');
      var eventEl = root.querySelector('.at-detail-event');
      var counterEl = root.querySelector('.at-detail-counter');
      var total = buttons.length;
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (img && btn.dataset.image) {
            img.src = btn.dataset.image;
            img.removeAttribute('srcset');
            img.alt = btn.dataset.title || '';
          }
          if (yearEl) yearEl.textContent = btn.dataset.year || '';
          if (titleEl) titleEl.textContent = btn.dataset.title || '';
          if (eventEl) eventEl.textContent = btn.dataset.event || '';
          if (counterEl) counterEl.textContent = 'Milestone ' + (i + 1) + ' of ' + total;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-about-why-shop"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-about-why-shop"].rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-apparel-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('[data-section-type="cs-apparel-cta"].rv');
  if (!('IntersectionObserver' in window)) {
    roots.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
  roots.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-artisan"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('.ac-wrap .rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      roots.forEach(function(el){ io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-sustainable"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('#su-{{ section.id }} .rv');
  if(!els.length) return;
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    els.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  },{ threshold: 0.12 });
  els.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-article-weekend"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('[data-section-type="cs-article-weekend"] .rv');
    if (!('IntersectionObserver' in window)) {
      roots.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    roots.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-california89"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.rv');
  if(!els.length) return;

  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    els.forEach(function(el){ el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  },{ threshold:0.12 });

  els.forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scopes = document.querySelectorAll('[data-section-type="cs-header"]');

    scopes.forEach(function (scope) {
      var headerRoot = scope.closest('header') || scope.parentNode || scope;
      var nav = scope;
      var burger = scope.querySelector('[data-hd-burger]');
      var drawer = headerRoot.querySelector('[data-hd-drawer]');
      var iconMenu = scope.querySelector('[data-hd-icon-menu]');
      var iconClose = scope.querySelector('[data-hd-icon-close]');

      if (nav) {
        var overHero = nav.getAttribute('data-hd-over-hero') === 'true';

        var onScroll = function () {
          if (window.scrollY > 50) {
            nav.classList.add('bg-white/98', 'backdrop-blur-md', 'shadow-sm');
            nav.classList.remove('bg-white');

            if (overHero) nav.classList.remove('hd-over-hero');
          } else {
            nav.classList.remove('bg-white/98', 'backdrop-blur-md', 'shadow-sm');

            if (overHero) {
              nav.classList.add('hd-over-hero');
              nav.classList.remove('bg-white');
            } else {
              nav.classList.add('bg-white');
            }
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      scope.querySelectorAll('[data-hd-dropdown]').forEach(function (dd) {
        var panel = dd.querySelector('.hd-panel');
        var isMega = panel && panel.classList.contains('hd-mega');
        var closeTimer = null;

        function positionMega() {
          if (!panel || !isMega) return;

          var rect = nav ? nav.getBoundingClientRect() : { bottom: 80 };
          panel.style.top = rect.bottom + 'px';
        }

        function openDropdown() {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }

          scope.querySelectorAll('[data-hd-dropdown].hd-open').forEach(function (o) {
            if (o !== dd) o.classList.remove('hd-open');
          });

          positionMega();
          dd.classList.add('hd-open');
        }

        function closeDropdown() {
          dd.classList.remove('hd-open');
        }

        function scheduleClose() {
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = setTimeout(closeDropdown, 180);
        }

        function cancelClose() {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        }

        dd.addEventListener('mouseenter', openDropdown);
        dd.addEventListener('mouseleave', scheduleClose);

        if (panel) {
          panel.addEventListener('mouseenter', cancelClose);
          panel.addEventListener('mouseleave', scheduleClose);
        }

        var trigger = dd.querySelector('a');

        if (trigger) {
          trigger.addEventListener('focus', openDropdown);

          dd.addEventListener('focusout', function (e) {
            if (!dd.contains(e.relatedTarget)) closeDropdown();
          });
        }

        if (isMega) {
          window.addEventListener('scroll', function () {
            if (dd.classList.contains('hd-open')) positionMega();
          }, { passive: true });
        }
      });

      if (!burger || !drawer) return;

      function openDrawer() {
        drawer.classList.remove('opacity-0', 'pointer-events-none');
        drawer.classList.add('opacity-100', 'pointer-events-auto');
        burger.setAttribute('aria-expanded', 'true');

        if (iconMenu) iconMenu.classList.add('hidden');
        if (iconClose) iconClose.classList.remove('hidden');
        if (nav) nav.classList.add('hd-drawer-open');

        document.documentElement.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.add('opacity-0', 'pointer-events-none');
        drawer.classList.remove('opacity-100', 'pointer-events-auto');
        burger.setAttribute('aria-expanded', 'false');

        if (iconMenu) iconMenu.classList.remove('hidden');
        if (iconClose) iconClose.classList.add('hidden');
        if (nav) nav.classList.remove('hd-drawer-open');

        document.documentElement.style.overflow = '';
      }

      function toggleDrawer() {
        if (burger.getAttribute('aria-expanded') === 'true') {
          closeDrawer();
        } else {
          openDrawer();
        }
      }

      function refreshPanel(panel) {
        if (!panel) return;

        var item = panel.closest('[data-hd-mobile-accordion]');

        if (item && item.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }

      drawer.querySelectorAll('[data-hd-mobile-accordion]').forEach(function (item) {
        var toggle = item.querySelector('[data-hd-mobile-toggle]');
        var panel = item.querySelector('[data-hd-mobile-panel]');

        if (!toggle || !panel) return;

        toggle.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          item.classList.toggle('is-open', !isOpen);
          toggle.setAttribute('aria-expanded', String(!isOpen));

          if (!isOpen) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          } else {
            panel.style.maxHeight = '0px';
          }
        });
      });

      drawer.querySelectorAll('[data-hd-mobile-subaccordion]').forEach(function (item) {
        var toggle = item.querySelector('[data-hd-mobile-subtoggle]');
        var panel = item.querySelector('[data-hd-mobile-subpanel]');

        if (!toggle || !panel) return;

        toggle.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          item.classList.toggle('is-open', !isOpen);
          toggle.setAttribute('aria-expanded', String(!isOpen));

          if (!isOpen) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          } else {
            panel.style.maxHeight = '0px';
          }

          var parentPanel = item.closest('[data-hd-mobile-panel]');

          if (parentPanel) {
            window.setTimeout(function () {
              var parentItem = parentPanel.closest('[data-hd-mobile-accordion]');

              if (parentItem && parentItem.classList.contains('is-open')) {
                parentPanel.style.maxHeight = parentPanel.scrollHeight + 'px';
              }
            }, 280);
          }
        });
      });

      window.addEventListener('resize', function () {
        drawer.querySelectorAll('[data-hd-mobile-panel]').forEach(refreshPanel);

        drawer.querySelectorAll('[data-hd-mobile-subpanel]').forEach(function (panel) {
          var item = panel.closest('[data-hd-mobile-subaccordion]');

          if (item && item.classList.contains('is-open')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });

      burger.addEventListener('click', toggleDrawer);

      drawer.addEventListener('click', function (e) {
        if (e.target.closest('a')) closeDrawer();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          closeDrawer();
        }
      });
    });

    function hdEscapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function hdNormalizeUrl(url) {
      if (!url) return '';

      url = String(url).trim();

      if (url.indexOf('//') === 0) {
        return window.location.protocol + url;
      }

      if (url.indexOf('/') === 0) {
        return window.location.origin + url;
      }

      return url;
    }

    function hdNormalizeResultUrl(url) {
      if (!url) return '';

      try {
        var parsed = new URL(url, window.location.origin);
        return parsed.origin + parsed.pathname;
      } catch (e) {
        return url;
      }
    }

    function hdGetHandleFromUrl(url, type) {
      if (!url) return '';

      try {
        var parsed = new URL(url, window.location.origin);
        var parts = parsed.pathname.split('/').filter(Boolean);
        var index = -1;

        if (type === 'product') {
          index = parts.indexOf('products');
        } else if (type === 'article') {
          index = parts.indexOf('blogs');

          if (index !== -1 && parts[index + 2]) {
            return parts[index + 2];
          }
        } else if (type === 'page') {
          index = parts.indexOf('pages');
        }

        if (index !== -1 && parts[index + 1]) {
          return parts[index + 1];
        }
      } catch (e) {}

      return '';
    }

    function hdClassifySearchUrl(url, title) {
      url = String(url || '').toLowerCase();
      title = String(title || '').toLowerCase();

      if (url.indexOf('/products/') !== -1) return 'product';
      if (url.indexOf('/blogs/') !== -1) return 'journal';
      if (url.indexOf('event') !== -1 || title.indexOf('event') !== -1) return 'event';

      return 'page';
    }

    function hdFindResultAnchor(img) {
      if (!img) return null;

      return img.closest('a[href]');
    }

    function hdIsLikelySearchResultImage(img) {
      if (!img) return false;

      var anchor = hdFindResultAnchor(img);
      if (!anchor) return false;

      var searchParent = img.closest(
        '[class*="search"], [id*="search"], [data-search], predictive-search, .predictive-search, .search-modal, .modal, [role="dialog"]'
      );

      return !!searchParent;
    }

    function hdSetSearchImage(img, imageUrl) {
      imageUrl = hdNormalizeUrl(imageUrl);

      if (!img || !imageUrl) return;

      img.classList.remove('hd-search-img-hidden');
      img.classList.add('hd-search-img-fixed');

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imageUrl;
    }

    function hdGetImageFromHtml(htmlText) {
      if (!htmlText) return '';

      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlText, 'text/html');

      var ogImage =
        doc.querySelector('meta[property="og:image"]') ||
        doc.querySelector('meta[name="og:image"]') ||
        doc.querySelector('meta[property="twitter:image"]') ||
        doc.querySelector('meta[name="twitter:image"]');

      if (ogImage && ogImage.getAttribute('content')) {
        return hdNormalizeUrl(ogImage.getAttribute('content'));
      }

      var firstImage =
        doc.querySelector('main img[src]') ||
        doc.querySelector('article img[src]') ||
        doc.querySelector('.article img[src]') ||
        doc.querySelector('.page img[src]') ||
        doc.querySelector('img[src]');

      if (firstImage) {
        return hdNormalizeUrl(
          firstImage.currentSrc ||
          firstImage.getAttribute('src') ||
          firstImage.getAttribute('data-src') ||
          firstImage.getAttribute('data-lazy-src')
        );
      }

      return '';
    }

    function hdFetchPageImage(url) {
      if (!url) return Promise.resolve('');

      return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Page image fetch failed');
          return response.text();
        })
        .then(function(htmlText) {
          return hdGetImageFromHtml(htmlText);
        })
        .catch(function() {
          return '';
        });
    }

    function hdFetchProductImage(handle) {
      if (!handle) return Promise.resolve('');

      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var productJsonUrl = root + 'products/' + encodeURIComponent(handle) + '.js';

      return fetch(productJsonUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Product image fetch failed');
          return response.json();
        })
        .then(function(product) {
          if (product.featured_image) return hdNormalizeUrl(product.featured_image);
          if (product.images && product.images.length) return hdNormalizeUrl(product.images[0]);

          return '';
        })
        .catch(function() {
          return '';
        });
    }

    function hdRepairBrokenSearchImage(img) {
      if (!img || img.dataset.hdSearchImgRepairing === 'true') return;
      if (!hdIsLikelySearchResultImage(img)) return;

      img.dataset.hdSearchImgRepairing = 'true';

      var anchor = hdFindResultAnchor(img);
      var url = anchor ? anchor.href : '';
      var title = anchor ? anchor.textContent.trim() : '';
      var type = hdClassifySearchUrl(url, title);

      var lazySrc =
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.getAttribute('data-lazy-src') ||
        img.getAttribute('data-image');

      if (lazySrc && lazySrc !== img.getAttribute('src')) {
        hdSetSearchImage(img, lazySrc);
        img.dataset.hdSearchImgRepairing = 'false';
        return;
      }

      var imagePromise;

      if (type === 'product') {
        imagePromise = hdFetchProductImage(hdGetHandleFromUrl(url, 'product'));
      } else {
        imagePromise = hdFetchPageImage(url);
      }

      imagePromise
        .then(function(imageUrl) {
          if (imageUrl) {
            hdSetSearchImage(img, imageUrl);
          } else {
            img.classList.add('hd-search-img-hidden');

            var thumb = img.closest('.hd-search-thumb, .hd-search-extra-thumb');
            if (thumb) thumb.classList.add('is-empty');
          }
        })
        .catch(function() {
          img.classList.add('hd-search-img-hidden');

          var thumb = img.closest('.hd-search-thumb, .hd-search-extra-thumb');
          if (thumb) thumb.classList.add('is-empty');
        })
        .finally(function() {
          img.dataset.hdSearchImgRepairing = 'false';
        });
    }

    function hdScanSearchImages(root) {
      root = root || document;

      root.querySelectorAll('img').forEach(function(img) {
        if (!hdIsLikelySearchResultImage(img)) return;

        img.addEventListener('error', function() {
          hdRepairBrokenSearchImage(img);
        });

        if (!img.getAttribute('src') || (img.complete && img.naturalWidth === 0)) {
          hdRepairBrokenSearchImage(img);
        }
      });
    }

    function hdFindOpenSearchContainer() {
      var selectors = [
        '.search-modal[open]',
        '.search-modal',
        'predictive-search',
        '.predictive-search',
        '[data-search]',
        '[id*="search"]',
        '[class*="search"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);

        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          var rect = node.getBoundingClientRect();

          if (rect.width > 0 && rect.height > 0 && window.getComputedStyle(node).display !== 'none') {
            if (node.querySelector('input[type="search"], input[name="q"]')) {
              return node;
            }
          }
        }
      }

      return null;
    }

    function hdFindSearchResultsContainer(searchContainer) {
      if (!searchContainer) return null;

      var selectors = [
        '[data-predictive-search-results]',
        '.predictive-search-results',
        '.predictive-search__results',
        '.search-results',
        '[class*="results"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var found = searchContainer.querySelector(selectors[i]);
        if (found) return found;
      }

      var links = searchContainer.querySelectorAll('a[href]');
      if (links.length) {
        return links[0].parentElement ? links[0].parentElement.closest('div, ul, ol, section') || links[0].parentElement : null;
      }

      return null;
    }

    function hdExtractResultsFromSearchHtml(htmlText, resultType, maxResults) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlText, 'text/html');

      var selector = 'a[href]';

      if (resultType === 'product') {
        selector = 'a[href*="/products/"]';
      } else if (resultType === 'journal') {
        selector = 'a[href*="/blogs/"]';
      } else if (resultType === 'page' || resultType === 'event') {
        selector = 'a[href*="/pages/"]';
      }

      var links = doc.querySelectorAll(selector);
      var results = [];
      var seen = {};

      links.forEach(function(anchor) {
        if (results.length >= maxResults) return;

        var rawUrl = anchor.getAttribute('href');
        var url = hdNormalizeResultUrl(rawUrl);
        if (!url || seen[url]) return;

        var title = '';
        var imageUrl = '';

        var card =
          anchor.closest('[class*="product"]') ||
          anchor.closest('[class*="article"]') ||
          anchor.closest('[class*="card"]') ||
          anchor.closest('.grid__item') ||
          anchor.closest('li') ||
          anchor.closest('article') ||
          anchor.parentElement;

        if (card) {
          var titleEl =
            card.querySelector('[class*="title"]') ||
            card.querySelector('h3') ||
            card.querySelector('h2') ||
            card.querySelector('a[href]');

          if (titleEl) {
            title = titleEl.textContent.trim();
          }

          var img = card.querySelector('img');

          if (img) {
            imageUrl =
              img.currentSrc ||
              img.getAttribute('src') ||
              img.getAttribute('data-src') ||
              img.getAttribute('data-original') ||
              img.getAttribute('data-lazy-src') ||
              '';
          }
        }

        if (!title) {
          title = anchor.getAttribute('aria-label') || anchor.getAttribute('title') || anchor.textContent.trim();
        }

        title = title.replace(/\s+/g, ' ').trim();

        var classifiedType = hdClassifySearchUrl(url, title);

        if (resultType === 'event' && classifiedType !== 'event') return;
        if (resultType === 'journal' && classifiedType !== 'journal') return;
        if (resultType === 'product' && classifiedType !== 'product') return;

        seen[url] = true;

        results.push({
          url: url,
          title: title || resultType,
          image: hdNormalizeUrl(imageUrl),
          type: classifiedType
        });
      });

      return results;
    }

    function hdFetchSearchResultsByType(query, resultType, maxResults) {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var pagesToFetch = [1, 2, 3, 4, 5];
      var allResults = [];
      var seen = {};

      var shopifyType = resultType;

      if (resultType === 'journal') {
        shopifyType = 'article';
      } else if (resultType === 'event') {
        shopifyType = 'page';
      }

      return pagesToFetch.reduce(function(promise, page) {
        return promise.then(function() {
          if (allResults.length >= maxResults) return;

          var url = root + 'search?q=' + encodeURIComponent(query) + '&type=' + encodeURIComponent(shopifyType) + '&page=' + page;

          return fetch(url, {
            method: 'GET',
            headers: {
              Accept: 'text/html'
            }
          })
            .then(function(response) {
              if (!response.ok) throw new Error('Search page failed');
              return response.text();
            })
            .then(function(htmlText) {
              var results = hdExtractResultsFromSearchHtml(htmlText, resultType, maxResults);

              results.forEach(function(result) {
                if (allResults.length >= maxResults) return;

                var key = hdNormalizeResultUrl(result.url);

                if (!seen[key]) {
                  seen[key] = true;
                  allResults.push(result);
                }
              });
            })
            .catch(function() {});
        });
      }, Promise.resolve()).then(function() {
        return allResults;
      });
    }

    function hdGetExistingSearchUrls(container) {
      var urls = {};
      if (!container) return urls;

      container.querySelectorAll('a[href]').forEach(function(anchor) {
        urls[hdNormalizeResultUrl(anchor.href)] = true;
      });

      return urls;
    }

    function hdGetCurrentSearchQuery() {
      var searchContainer = hdFindOpenSearchContainer();
      if (!searchContainer) return '';

      var input = searchContainer.querySelector('input[type="search"], input[name="q"]');
      return input ? input.value.trim() : '';
    }

    function hdRenderExtraResult(result) {
      var typeLabel = result.type === 'journal' ? 'Journal' : result.type === 'event' ? 'Event' : result.type === 'product' ? 'Product' : 'Page';

      var html = '';

      html += '<a class="hd-search-extra-result" href="' + hdEscapeHtml(result.url) + '">';
      html += '<div class="hd-search-extra-thumb' + (result.image ? '' : ' is-empty') + '">';

      if (result.image) {
        html += '<img src="' + hdEscapeHtml(result.image) + '" alt="' + hdEscapeHtml(result.title) + '" loading="lazy">';
      }

      html += '<div class="hd-search-extra-placeholder">No image</div>';
      html += '</div>';
      html += '<div>';
      html += '<span class="hd-search-extra-type">' + hdEscapeHtml(typeLabel) + '</span>';
      html += '<h3 class="hd-search-extra-title">' + hdEscapeHtml(result.title) + '</h3>';
      html += '</div>';
      html += '</a>';

      return html;
    }

    function hdCountVisibleResults(searchContainer) {
      var counts = {
        product: 0,
        journal: 0,
        event: 0,
        page: 0,
        all: 0
      };

      if (!searchContainer) return counts;

      var seen = {};

      searchContainer.querySelectorAll('a[href]').forEach(function(anchor) {
        var url = hdNormalizeResultUrl(anchor.href);
        if (!url || seen[url]) return;

        var type = hdClassifySearchUrl(url, anchor.textContent);
        seen[url] = true;

        if (counts[type] !== undefined) {
          counts[type]++;
        } else {
          counts.page++;
        }

        counts.all++;
      });

      return counts;
    }

    function hdUpdateSearchCounters(searchContainer, counts) {
      if (!searchContainer || !counts) return;

      var tabCandidates = searchContainer.querySelectorAll('button, a, span');

      tabCandidates.forEach(function(el) {
        var directText = '';

        el.childNodes.forEach(function(node) {
          if (node.nodeType === Node.TEXT_NODE) {
            directText += node.textContent;
          }
        });

        var text = directText.trim();

        if (!text) {
          text = (el.getAttribute('aria-label') || '').trim();
        }

        if (!text) return;

        var normalized = text.replace(/\s+/g, ' ').toLowerCase();
        var base = text.replace(/\s*\(\d+\)\s*/g, '').trim();

        if (!base) return;

        var newText = null;

        if (normalized === 'all' || normalized.indexOf('all ') === 0) {
          newText = base + ' (' + counts.all + ')';
        } else if (normalized === 'products' || normalized === 'product' || normalized.indexOf('products ') === 0 || normalized.indexOf('product ') === 0) {
          newText = base + ' (' + counts.product + ')';
        } else if (normalized === 'journal' || normalized === 'journals' || normalized === 'article' || normalized === 'articles' || normalized.indexOf('journal ') === 0 || normalized.indexOf('article ') === 0) {
          newText = base + ' (' + counts.journal + ')';
        } else if (normalized === 'events' || normalized === 'event' || normalized.indexOf('events ') === 0 || normalized.indexOf('event ') === 0) {
          newText = base + ' (' + counts.event + ')';
        }

        if (!newText) return;

        var updated = false;

        el.childNodes.forEach(function(node) {
          if (!updated && node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = node.textContent.replace(node.textContent.trim(), newText);
            updated = true;
          }
        });

        if (!updated && el.children.length === 0) {
          el.textContent = newText;
        }
      });
    }

    function hdAppendExtraSearchResults(query) {
      if (!query || query.trim().length < 2) return;

      var searchContainer = hdFindOpenSearchContainer();
      if (!searchContainer) return;

      var resultsContainer = hdFindSearchResultsContainer(searchContainer);
      if (!resultsContainer) return;

      var maxResults = 50;

      if (resultsContainer.dataset.hdExtraSearchQuery === query) {
        var currentCounts = hdCountVisibleResults(searchContainer);
        hdUpdateSearchCounters(searchContainer, currentCounts);
        return;
      }

      resultsContainer.dataset.hdExtraSearchQuery = query;

      Promise.all([
        hdFetchSearchResultsByType(query, 'product', maxResults),
        hdFetchSearchResultsByType(query, 'journal', maxResults),
        hdFetchSearchResultsByType(query, 'event', maxResults)
      ]).then(function(groups) {
        var products = groups[0] || [];
        var journals = groups[1] || [];
        var events = groups[2] || [];

        var all = products.concat(journals).concat(events);
        if (!all.length) return;

        var existing = hdGetExistingSearchUrls(resultsContainer);
        var html = '';

        all.forEach(function(result) {
          var key = hdNormalizeResultUrl(result.url);
          if (existing[key]) return;

          existing[key] = true;
          html += hdRenderExtraResult(result);
        });

        if (html) {
          var oldExtra = resultsContainer.querySelector('.hd-search-extra-results');

          if (oldExtra) {
            oldExtra.remove();
          }

          var wrap = document.createElement('div');
          wrap.className = 'hd-search-extra-results';
          wrap.innerHTML = html;
          resultsContainer.appendChild(wrap);
          hdScanSearchImages(wrap);
        }

        var updatedCounts = hdCountVisibleResults(searchContainer);

        updatedCounts.product = Math.max(updatedCounts.product, products.length);
        updatedCounts.journal = Math.max(updatedCounts.journal, journals.length);
        updatedCounts.event = Math.max(updatedCounts.event, events.length);
        updatedCounts.all = updatedCounts.product + updatedCounts.journal + updatedCounts.event + updatedCounts.page;

        hdUpdateSearchCounters(searchContainer, updatedCounts);
      });
    }

    document.addEventListener(
      'error',
      function(event) {
        var target = event.target;

        if (target && target.tagName === 'IMG') {
          hdRepairBrokenSearchImage(target);
        }
      },
      true
    );

    var hdSearchImageObserver = new MutationObserver(function(mutations) {
      var shouldAppend = false;

      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!node || node.nodeType !== 1) return;

          if (node.tagName === 'IMG') {
            hdScanSearchImages(node.parentNode || document);
          } else {
            hdScanSearchImages(node);
          }

          if (
            node.querySelector &&
            (
              node.querySelector('a[href*="/products/"]') ||
              node.querySelector('a[href*="/blogs/"]') ||
              node.querySelector('a[href*="/pages/"]') ||
              node.matches('a[href*="/products/"], a[href*="/blogs/"], a[href*="/pages/"]')
            )
          ) {
            shouldAppend = true;
          }
        });
      });

      if (shouldAppend) {
        window.clearTimeout(window.hdExtraSearchTimer);

        window.hdExtraSearchTimer = window.setTimeout(function() {
          var query = hdGetCurrentSearchQuery();
          hdAppendExtraSearchResults(query);
        }, 350);
      }
    });

    hdSearchImageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('input', function(event) {
      var input = event.target;

      if (!input || !input.matches('input[type="search"], input[name="q"]')) return;

      var container = input.closest(
        '[class*="search"], [id*="search"], [data-search], predictive-search, .predictive-search, .search-modal, .modal, [role="dialog"]'
      );

      if (!container) return;

      window.clearTimeout(window.hdExtraSearchInputTimer);

      window.hdExtraSearchInputTimer = window.setTimeout(function() {
        hdAppendExtraSearchResults(input.value.trim());
      }, 900);
    });

    hdScanSearchImages(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scroll reveal with stagger
    var cards = document.querySelectorAll('.pc-card-shop');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var delay = Array.from(cards).indexOf(entry.target) % 4 * 80;
            setTimeout(function () { entry.target.classList.add('spr-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('spr-visible'); });
    }

    // Sort
    var sortEl = document.querySelector('.spr-sort');
    var grid = document.querySelector('.spr-wrap .grid');
    if (sortEl && grid) {
      sortEl.addEventListener('change', function () {
        var allCards = Array.from(grid.querySelectorAll('.pc-card-shop'));
        var visible = allCards.filter(function (c) { return !c.hidden; });
        var hidden = allCards.filter(function (c) { return c.hidden; });
        var val = sortEl.value;
        visible.sort(function (a, b) {
          if (val === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
          if (val === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
          return 0;
        });
        visible.forEach(function (c) { grid.appendChild(c); });
        hidden.forEach(function (c) { grid.appendChild(c); });
      });
    }

    // Listen for filter events from subnav
    document.addEventListener('ssn:filter', function (e) {
      var filter = e.detail.filter;
      var allCards = document.querySelectorAll('.pc-card-shop');
      var count = 0;
      allCards.forEach(function (c) {
        var tags = (c.dataset.tags || '').split(',').map(function (t) { return t.trim(); }).filter(function (t) { return t !== ''; });
        var show = filter === 'all' || tags.some(function (t) {
          return t.indexOf(filter) !== -1 || filter.indexOf(t) !== -1;
        });
        if (show) { c.removeAttribute('hidden'); count++; }
        else { c.setAttribute('hidden', ''); }
      });
      var countEl = document.querySelector('.spr-count');
      if (countEl) countEl.textContent = count;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-shop-subnav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-shop-subnav"]').forEach(function (section) {
      section.querySelectorAll('.ssn-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          // Active state
          section.querySelectorAll('.ssn-pill').forEach(function (p) {
            p.classList.remove('ssn-active');
            p.style.borderColor = '';
            p.style.color = '';
          });
          pill.classList.add('ssn-active');

          // Fire filter event
          var filter = pill.dataset.filter || 'all';
          document.dispatchEvent(new CustomEvent('ssn:filter', { detail: { filter: filter } }));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-stores-gallery"]').forEach(function (section) {
      var slides = section.querySelectorAll('[data-gallery-slide]');
      var dots = section.querySelectorAll('[data-gallery-dot]');
      var prevBtn = section.querySelector('[data-gallery-prev]');
      var nextBtn = section.querySelector('[data-gallery-next]');
      var count = slides.length;
      if (count === 0) return;
      var currentIndex = 0;

      function render() {
        slides.forEach(function (s) {
          var idx = parseInt(s.getAttribute('data-index'), 10);
          s.classList.toggle('hidden', idx !== currentIndex);
        });
        dots.forEach(function (d) {
          var idx = parseInt(d.getAttribute('data-index'), 10);
          var active = idx === currentIndex;
          d.classList.toggle('is-active', active);
          if (active) {
            d.classList.add('bg-[var(--c-accent-3)]', 'w-6');
            d.classList.remove('bg-[var(--c-border-2)]', 'w-2');
          } else {
            d.classList.remove('bg-[var(--c-accent-3)]', 'w-6');
            d.classList.add('bg-[var(--c-border-2)]', 'w-2');
          }
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + count) % count;
        render();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % count;
        render();
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          currentIndex = parseInt(d.getAttribute('data-index'), 10);
          render();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.parentElement;
    // Scope handlers per section instance
    document.querySelectorAll('[data-section-type="cs-stores-selector"]').forEach(function (section) {
      var tabs = section.querySelectorAll('[data-store-target]');
      var panels = section.querySelectorAll('[data-store-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-store-target');
          tabs.forEach(function (t) {
            var isActive = t.getAttribute('data-store-target') === target;
            t.classList.toggle('is-active', isActive);
            if (isActive) {
              t.classList.add('border-[var(--c-accent-3)]', 'bg-[var(--c-accent-3)]', 'text-white');
              t.classList.remove('border-[var(--c-border-2)]', 'bg-white', 'text-[var(--c-text)]');
            } else {
              t.classList.remove('border-[var(--c-accent-3)]', 'bg-[var(--c-accent-3)]', 'text-white');
              t.classList.add('border-[var(--c-border-2)]', 'bg-white', 'text-[var(--c-text)]');
            }
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-store-panel') === target;
            p.classList.toggle('hidden', !match);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-stores-services"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="cs-stores-services"]').forEach(function (section) {
      var openers = section.querySelectorAll('[data-modal-target]');
      var panels = section.querySelectorAll('[data-modal-panel]');

      function closeAll() {
        panels.forEach(function (p) { p.classList.add('hidden'); });
        document.body.classList.remove('overflow-hidden');
      }

      openers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-modal-target');
          panels.forEach(function (p) {
            var match = p.getAttribute('data-modal-panel') === id;
            p.classList.toggle('hidden', !match);
          });
          document.body.classList.add('overflow-hidden');
        });
      });

      panels.forEach(function (panel) {
        panel.addEventListener('click', function (e) {
          // Backdrop click closes
          if (e.target === panel) {
            closeAll();
          }
        });
        var closeBtn = panel.querySelector('[data-modal-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closeAll();
          });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('.msr-wrap.rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
